<template>
  <div class="step-three">
    <div class="w-item">
      <div class="w-title"
        >餐卡得分<span class="score">{{ averageScore }}分</span></div
      >
      <RadarComponent
        v-if="data.scoreData"
        ref="radar"
        :data="data.scoreData"
      ></RadarComponent>
    </div>
    <div class="w-item" v-if="tagList.length">
      <div class="w-title">饮食特点</div>
      <div class="tag-list">
        <div
          class="tag-item"
          :class="[item.color]"
          v-for="(item, index) in tagList"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="tag-list"></div>
    </div>
    <div class="w-item">
      <div class="w-title">饮食分析</div>
      <div class="d-list">
        <div
          class="d-item"
          v-for="(item, index) in data.reviewData"
          :key="index"
        >
          <div class="d-title">{{ item.name }}</div>
          <div class="d-text r-text" v-html="item.value"> </div>
        </div>
      </div>
    </div>
    <div class="w-item" v-if="data.dietaryAdvice.value">
      <div class="w-title">未来饮食建议</div>
      <div class="r-text" v-html="data.dietaryAdvice.value"></div>
    </div>
    <div class="w-item" v-if="data.exceptionDesc && data.exceptionDesc.value">
      <div class="w-title">异常描述</div>
      <div class="r-text" v-html="data.exceptionDesc.value"></div>
    </div>
  </div>
</template>
<script>
import RadarComponent from './step-three/radar.vue'
export default {
  components: {
    RadarComponent
  },
  props: {
    autoShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    labelData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tagList() {
      let res = []
      let obj = {
        优点: 'green',
        缺点: 'red'
      }
      this.labelData.map((item) => {
        item.list.map((item1) => {
          if (item1.checked) {
            item1.color = obj[item.name] || ''
            res.push(item1)
          }
        })
      })
      return res
    },
    //平均分
    averageScore() {
      let total = 0
      this.data.scoreData.map((item) => {
        total = total + (item.score || 0)
      })
      let res = Math.round(total / this.data.scoreData.length)
      return res
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  watch: {},
  mounted() {
    if (this.autoShow) {
      this.initRadar()
    }
  },
  methods: {
    initRadar() {
      setTimeout(() => {
        this.loaded = true
      }, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.step-three {
  .w-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
    .w-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      margin-bottom: 10px;
    }
    .score {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #6236ff;
      line-height: 25px;
      margin-left: 20px;
    }
    .tag-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tag-item {
        height: 24px;
        padding: 0px 20px;
        background: #f9f9f9;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
        white-space: nowrap;
        margin: 3px 0px;
        margin-right: 6px;
      }
      .green {
        color: rgba(43, 183, 155, 1);
      }
      .red {
        color: rgba(240, 70, 70, 1);
      }
      .tag-item:last-child {
        margin-right: 0px;
      }
    }
    .d-list {
      .d-item {
        .d-title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-bottom: 9px;
        }
        .d-text {
          margin-bottom: 18px;
        }
      }
    }
    .r-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 24px;
      white-space: pre-line;
      word-break: break-all;
    }
  }
}
</style>
